import { render, staticRenderFns } from "./PortfolioCreatorDialog.vue?vue&type=template&id=32cff670"
import script from "./PortfolioCreatorDialog.vue?vue&type=script&lang=ts"
export * from "./PortfolioCreatorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports